const ERC721ABI = `[
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "tokenName",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "tokenSymbol",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "customBaseURI_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "payees",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "shares",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256",
        "name": "_tokenPrice",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_tokensForSale",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "approved",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "MAX_SUPPLY",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "PRICE",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "baseTokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "flipSaleState",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "getApproved",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "ownerMint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ownerOf",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address payable",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "release",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "_data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "saleIsActive",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "customBaseURI_",
        "type": "string"
      }
    ],
    "name": "setBaseURI",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_tokenPrice",
        "type": "uint256"
      }
    ],
    "name": "setPrice",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "tokenURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_owner",
        "type": "address"
      }
    ],
    "name": "tokensOfOwner",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "ownerTokens",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
]`;

const ERC721ByteCode = "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";

export {ERC721ABI, ERC721ByteCode}
